import { put } from 'redux-saga/effects';
import { signalingWhiteboardAlreadyOpened } from 'features/layout/features/content/actions';
import { openModal } from 'features/modal/modalSlice';

export function* onWhiteboardAlreadyOpenedSaga(
  action: ReturnType<typeof signalingWhiteboardAlreadyOpened>
) {
  yield put(openModal('whiteboardAlreadyOpened', { whiteboardId: action.payload.fileId }));
}
